<template>
  <Modal
      v-model="_value"
      width="400"
      title="添加/修改车辆识别码"
      @on-visible-change="visibleChange"
      ok-text="添加"
      @on-ok="onOk">
      <div>
    <Form ref="loginForm" :model="vehicleInfo" >
      <FormItem prop="name">
          <label>
            车辆识别码：
          </label>
        <Input v-model="vehicleInfo.identificationCode" placeholder="请输入车辆识别码">
        </Input>
      </FormItem>
    </Form>
      </div>
  </Modal>
</template>
<script>

  import Vue from 'vue';
  import {mapActions} from 'vuex'
  import store from '@/store'
  import {genQueryParam, genSortParam} from "@/libs/queryparamhelper"

  export default {
    name: 'vehicleidentificationcodemodal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      initValue: null,
      installed: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        vehicleInfo: {
          identificationCode:null
        },
        installOrder:{
      },
      }
    },
    methods: {
      ...mapActions([
        'UserGroupServ_AddObj'
      ]),
      onOk() {
        if (this.installed) {
          this.$Modal.confirm({
            title: '添加/修改车辆识别码',
            content: '<p>是否确认添加车辆分组</p>',
            onOk: () => {
              store.dispatch('VehicleInfoServ_ModifyObj', {params: this.vehicleInfo}).then(() => {
                this.$Message.success('添加/修改车辆识别码')
                this.$emit('on-success');
              }).catch(err => {
                this.$Message.error(err)
                this.$emit('on-fail');
              })
            },
            onCancel: () => {
            }
          })
        } else {
          this.installOrder.tempVehicleInfo.identificationCode = this.vehicleInfo.identificationCode
          this.$Modal.confirm({
            title: '添加/修改车辆识别码',
            content: '<p>是否确认添加车辆分组</p>',
            onOk: () => {
              store.dispatch('InstallOrderServ_ModifyObj', {params: this.installOrder}).then(() => {
                this.$Message.success('添加/修改车辆识别码')
                this.$emit('on-success');
              }).catch(err => {
                this.$Message.error(err)
                this.$emit('on-fail');
              })
            },
            onCancel: () => {
            }
          })
        }
      },
      visibleChange(val) {
        if(val){
          this.vehicleInfo.identificationCode = null

          if (this.installed) {
          store.dispatch('VehicleInfoServ_GetDetail',{
            params:{
              id:this._initValue
            },
            urlparams:null
          }).then(res=>{
            if (store.getters.get_VehicleInfo_GetDetailResult) {
              this.vehicleInfo = store.getters.get_VehicleInfo_GetDetailResult

            }
          }).catch(err=>{
            console.log(err)
            this.$Message.error(err)
          })
          } else {
            store.dispatch('InstallOrderServ_GetDetail',{
              params:{
                id:this._initValue
              },
              urlparams:null
            }).then(res=>{
              if (store.getters.get_InstallOrder_GetDetailResult) {
                this.installOrder = store.getters.get_InstallOrder_GetDetailResult
                this.vehicleInfo.identificationCode = store.getters.get_InstallOrder_GetDetailResult.tempVehicleInfo.identificationCode
              }
            }).catch(err=>{
              console.log(err)
              this.$Message.error(err)
            })
          }
        }
      },
    },
    computed: {
      _value: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _installed: {
        get () {
          return this.installed
        },
        set (val) {
          // this.$emit('input', val)
          // this.$emit('change', val)
        }
      },
      _initValue: {
        get() {
          return this.initValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      },
    },
    mounted() {
      this.$nextTick(() => {

      })
    }
  }
</script>
<style>
  .demo-split{
    height: 500px;
    border: 1px solid #dcdee2;
  }
  .demo-split-pane{
    padding: 10px;
  }
</style>
